var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeStudioIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "red",
      fillOpacity: 1
    },
    d: "M11.129 1.21c.48-.28 1.262-.28 1.742 0l8.008 4.642c.48.277.871.968.871 1.527v9.242c0 .559-.39 1.25-.871 1.527L12.87 22.79c-.48.281-1.262.281-1.742 0L3.12 18.15c-.48-.278-.871-.97-.871-1.528V7.38c0-.559.39-1.25.871-1.527zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "m12.71 18.98 4.9-2.832c.41-.238.64-.77.64-1.238V9.238c0-.468-.23-1-.64-1.238l-4.9-2.82c-.41-.23-1.019-.23-1.42 0L6.39 8c-.402.23-.64.77-.64 1.238v5.672c0 .469.238 1 .64 1.238l4.9 2.832c.198.122.46.18.71.18.262-.012.512-.07.71-.18zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "red",
      fillOpacity: 1
    },
    d: "m12.32 5.73 4.89 2.829c.161.09.411.312.411.671v5.668c0 .372-.25.543-.41.641l-4.89 2.832c-.16.09-.481.09-.641 0L6.79 15.54c-.161-.09-.411-.34-.411-.64v-5.66a.848.848 0 0 1 .41-.68l4.89-2.829c.083-.05.2-.07.321-.07s.238.02.32.07zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M9.879 15.25 15.5 12 9.879 8.75zm0 0"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeStudioIcon);
export default __webpack_public_path__ + "static/media/youtube_studio_icon.a61f8c5799eee57d29da69a02425c63e.svg";
export { ForwardRef as ReactComponent };